<template>
  <div class="sideMenu d-flex flex-column" :style="$store.getters.getMobileMenuState ? 'left:0;' : 'left:-330px;'">
    <div class="d-flex justify-space-between info-box-list">
      <img id="logo-img" :src="'/apaly1.png'" class="pointer" height="32px"/>
      <div @click="$store.commit('openMobileMenu',false)">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1.5L8.5 8.5" stroke="#16407A" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M1.5 8.5L8.5 1.5" stroke="#16407A" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
    <div class="info-box-list" @click="navigateTo('Home')" >
      <div class="d-flex info-box-list-item">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.999999 10.0806L12 1.28062L23 10.0806L23 23L16.12 23V17.52C16.12 15.2446 14.2754 13.4 12 13.4C9.72458 13.4 7.88 15.2446 7.88 17.52L7.88 23H1L0.999999 10.0806Z" stroke="#16407A" stroke-width="2"/>
        </svg>
        <div>Home</div>
      </div>
    </div>

   <div class="info-box-list" @click="navigateTo('FindCare')" >
      <div class="d-flex info-box-list-item">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1C18.9706 1 23 5.02944 23 10C23 14.9706 18.9706 19 14 19C9.02944 19 5 14.9706 5 10C5 5.02944 9.02944 1 14 1Z" stroke="#16407A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 17L1 23" stroke="#16407A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>Find Care</div>
      </div>
    </div>
   <div class="info-box-list" @click="navigateTo('marketplace')" >
      <div class="d-flex info-box-list-item">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1C18.9706 1 23 5.02944 23 10C23 14.9706 18.9706 19 14 19C9.02944 19 5 14.9706 5 10C5 5.02944 9.02944 1 14 1Z" stroke="#16407A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 17L1 23" stroke="#16407A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>Marketplace</div>
      </div>
    </div>
   <div class="info-box-list" @click="navigateTo('account')" >
      <div class="d-flex info-box-list-item">
        <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 11C9.92627 11 8.90438 10.5902 8.15707 9.87273L7.46454 10.5941L8.15707 9.87273C7.41113 9.15662 7 8.19431 7 7.2V4.8C7 3.80569 7.41113 2.84338 8.15707 2.12727C8.90438 1.40985 9.92627 1 11 1C12.0737 1 13.0956 1.40985 13.8429 2.12727C14.5889 2.84338 15 3.80569 15 4.8V7.2C15 8.19431 14.5889 9.15662 13.8429 9.87273C13.0956 10.5902 12.0737 11 11 11Z" stroke="#16407A" stroke-width="2" stroke-miterlimit="10"/>
          <path d="M5.59851 14.1251C5.80093 14.0824 6.0456 14.1037 6.37441 14.2138C6.70484 14.3245 7.03847 14.4946 7.44085 14.6997C7.4536 14.7062 7.46642 14.7128 7.47931 14.7193C8.2958 15.1355 9.45654 15.5 11 15.5C12.5434 15.5 13.704 15.1356 14.5205 14.7194L14.5592 14.6997C14.9615 14.4946 15.2951 14.3245 15.6255 14.2138C15.9544 14.1037 16.1991 14.0824 16.4015 14.1251C17.4921 14.3555 18.5022 14.8976 19.3023 15.6978C20.3893 16.7848 21 18.2591 21 19.7964C21 21.5657 19.5657 23 17.7964 23L4.20361 23C2.43431 23 1 21.5657 1 19.7964C1 19.0352 1.1499 18.2815 1.44119 17.5782C1.73249 16.875 2.15945 16.236 2.6977 15.6978C3.23596 15.1595 3.87492 14.7325 4.57816 14.4413C4.90863 14.3044 5.25023 14.1987 5.59851 14.1251Z" stroke="#16407A" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
        <div>Account</div>
      </div>
    </div>
   <div class="info-box-list" @click="navigateTo('contactUsIndex')" >
    <div class="d-flex info-box-list-item">
        <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.76431 14.6218L3.76974 14.6313L3.77538 14.6407L3.81711 14.7101L3.85958 14.7878L3.86514 14.798L3.87092 14.808C5.57412 17.7615 7.88893 20.1161 9.94875 21.52C10.9702 22.2162 11.9908 22.7211 12.8886 22.9134C13.7351 23.0947 14.8807 23.0556 15.482 22.0469L15.4954 22.0244L15.5076 22.0013L16.8176 19.517L16.8302 19.4931L16.8414 19.4686C16.964 19.2023 17.017 18.9091 16.9953 18.6167C16.975 18.3434 16.8901 18.0792 16.7481 17.8456C16.6769 17.713 16.5891 17.5788 16.4683 17.4481C16.34 17.3091 16.2038 17.2061 16.0823 17.1229C15.9822 17.0543 15.8617 16.9791 15.7384 16.9023C15.7205 16.8911 15.7026 16.8799 15.6846 16.8687C15.5388 16.7776 15.3632 16.6671 15.1433 16.5218C14.6741 16.1761 14.1896 15.7969 13.8598 15.5172C13.5409 15.2195 13.1253 15.0459 12.6886 15.0286C12.2381 15.0107 11.7968 15.1606 11.4504 15.4492L11.4158 15.478L11.384 15.5097L10.9047 15.9881C10.8768 15.9679 10.8436 15.9423 10.8051 15.9103C10.611 15.7485 10.3712 15.497 10.1022 15.1732C9.56866 14.5308 9.01562 13.7205 8.60868 13.0876L8.60831 13.0871C8.37689 12.7278 8.21322 12.4531 8.12985 12.2936C8.06219 12.1641 7.96239 11.985 7.85241 11.7875C7.7861 11.6684 7.71609 11.5427 7.64719 11.4172C7.30779 10.7515 6.89567 9.87362 6.6154 9.098C6.47317 8.70438 6.37772 8.37177 6.33567 8.12381C6.32886 8.08366 6.32398 8.04869 6.32054 8.01859L6.98324 7.83748L7.02305 7.8266L7.06183 7.81248C7.48376 7.65882 7.83444 7.35462 8.04578 6.95773C8.25191 6.57064 8.31105 6.12249 8.21294 5.69578C8.14356 5.32898 8.07843 4.80632 8.00849 4.24505C8.00141 4.18818 7.99427 4.13091 7.98707 4.07337C7.97557 3.85151 7.96795 3.63827 7.96133 3.45286C7.95405 3.24901 7.94797 3.0788 7.93924 2.96776C7.91271 2.63016 7.84498 2.36096 7.66579 2.04946C7.53278 1.7986 7.34007 1.58421 7.10458 1.42521C6.85901 1.25939 6.57497 1.15921 6.27957 1.13433L6.26085 1.13275L6.24207 1.13188L3.43002 1.00116L3.41324 1.00038L3.39643 1.00016C2.21355 0.984959 1.59033 1.94921 1.31617 2.77003C1.0266 3.63696 0.947034 4.76888 1.03236 5.99745C1.20448 8.47597 2.07047 11.6596 3.76431 14.6218ZM11.0077 16.052C11.0077 16.0521 11.0061 16.0515 11.0029 16.0499C11.006 16.0511 11.0077 16.0519 11.0077 16.052ZM6.31468 7.87821C6.31474 7.87827 6.31459 7.88023 6.31402 7.8839C6.31433 7.87998 6.31461 7.87814 6.31468 7.87821Z" stroke="#16407A" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
        <div>Contact us</div>
      </div>
   </div>
  </div>

</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    navigateTo(pathName){
      this.$store.commit('openMobileMenu',false)
      this.$router.push({name:pathName})
    }
  },
};
</script>

<style scoped lang="scss">
.sideMenu{
  position: absolute;
  left: -330px;
  z-index:2;
  width: 330px;
  height: 100vh;
  background: white;
  padding:20px;
}
.info-box-list{
  padding: 15px;
  margin: 5px 0;
  border-bottom: 1px solid #C9C9C9;
  text-decoration: none;
}
.info-box-list:last-child{
  border-bottom: none;
}

.info-box-list-item  > svg {
  margin-right: 10px;
}

.info-box-list-item > div {
  font-weight: bold;
  color: #16407A;
}
</style>
